import { render, staticRenderFns } from "./StoryCard.vue?vue&type=template&id=3b38e16e&"
import script from "./StoryCard.vue?vue&type=script&lang=js&"
export * from "./StoryCard.vue?vue&type=script&lang=js&"
import style0 from "./StoryCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryCard.vue
// module id = 1040
// module chunks = 0